export enum ConnectionTypeDesktopEnum {
  USB = 'USB',
  BLUETOOTH = 'BLUETOOTH',
  UHF = 'UHF',
  UART = 'UART',
  NATIVE_BLUETOOTH = 'NATIVE_BLUETOOTH',
}
